<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="2"></v-col>
      <v-col cols="12" sm="12" md="8">
        <v-card class="mx-auto my-5 mb-16" max-width="1000">
          <v-app-bar flat>
            <span class="headline">{{ formCompData.title }}</span>
          </v-app-bar>
          <v-card-text>
            <v-container>
              <formComponent
                ref="formComponent"
                :form="formComp"
                v-model="formComp.eventForm"
              />
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="grey" outlined @click="closeform">{{
              $t("general.back")
            }}</v-btn>
            <v-btn color="primary" @click="saveForm(false)">
              <div
                v-if="
                  $route.params.mode === 'new' || $route.params.mode === 'copy'
                "
              >
                {{ $t("general.save") }}
              </div>
              <div v-if="$route.params.mode === 'edit'">
                {{ $t("general.saveChanges") }}
              </div>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="2"></v-col>
    </v-row>
  </div>
</template>

<script>
function getDefaultData() {
  return { name: "" };
}
import formComponent from "../../components/_utils/formComponent/formComponent.vue";
import i18n from "../../i18n";
import { getUniqueId } from "../../components/api/api";

export default {
  components: { formComponent },
  data: () => ({
    formCompData: { title: "" },
    formComp: {
      eventForm: getDefaultData(),
      form: [
        [
          {
            cols: 12,
            class: "pb-0 pt-0",
            id: getUniqueId(),
            componentName: "vTextField",
            config: {
              vModel: "name",
              label: i18n.t("inspections.category.titleLabel"),
              dataCy: "name",
              rules: [(v) => !!v || i18n.t("general.fieldNeedsToBeFilled")],
            },
          },
        ],
      ],
    },
  }),
  mounted() {
    this.switchFormModes(this.$route.params.mode, this.$route.params);
  },
  methods: {
    switchFormModes(mode, params) {
      switch (mode) {
        case "edit":
          this.$store
            .dispatch("getSingleInspectionCategory", params.id)
            .then((item) => {
              this.formCompData.title = this.$t("inspections.category.edit");
              this.formComp.eventForm = item;
            });
          break;
        case "copy":
          this.$store
            .dispatch("getSingleInspectionCategory", params.id)
            .then((item) => {
              this.formCompData.title = this.$t("inspections.category.copy");
              this.formComp.eventForm = item;
              delete this.formComp.eventForm._id;
              delete this.formComp.eventForm.id;
              delete this.formComp.eventForm.isDefault;
              delete this.formComp.eventForm.createdAt;
              delete this.formComp.eventForm.updatedAt;
            });
          break;
        case "new":
          this.formCompData.title = this.$t("inspections.category.newTitle");
          break;
      }
    },
    closeform() {
      this.$router.back();
    },
    saveForm() {
      if (this.$refs.formComponent.validateAllFields()) {
        if (
          this.$route.params.mode === "new" ||
          this.$route.params.mode === "copy"
        ) {
          this.$store
            .dispatch("createInspectionCategory", this.formComp.eventForm)
            .then(() => {
              this.closeform();
            });
        } else {
          this.$store
            .dispatch("updateInspectionCategory", this.formComp.eventForm)
            .then(() => {
              this.closeform();
            });
        }
      }
    },
  },
};
</script>
